// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"98":"1c343d76","288":"b21fb478","364":"1e35e0ce"}[chunkId] + ".css";
};